import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern: string = 'fullDate'): any {
    const datePipe: DatePipe = new DatePipe(this.translateService.getFallbackLang() ?? 'es');
    return datePipe.transform(value, pattern);
  }
}
